<script setup>
defineProps({
  src: { type: String, default: null },
  alt: { type: String, default: "" },
});
</script>

<template>
  <div
    class="relative h-[120px] overflow-hidden rounded-t-[var(--radius)] cursor-pointer"
    aria-hidden="true"
  >
    <img
      v-if="src"
      :src="src"
      :alt="alt"
      class="absolute inset-0 h-full w-full object-cover"
      loading="lazy"
      decoding="async"
      fetchpriority="low"
    />
    <div
      v-else
      class="absolute inset-0"
      :style="{
        background:
          'radial-gradient(circle at top left, #4fc3f7 0%, transparent 40%), repeating-radial-gradient(circle at left center, #4fc3f7 0 20px, #7dd3fc 20px 40px)',
        filter: 'blur(0.5px)',
      }"
    />
  </div>
</template>
